import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import CardCustom from './cards';
import Barra from './barra';
import Pizza from './pizza';
import { instanceAxios } from '../../InstanceAxios';

function Financeiro() {
  const useStyles = makeStyles((theme) => ({
    cards: {
      padding: '2%',
    },
    root: {
      width: '100%',
    },
    paper: {
      position: 'absolute',
      width: 600,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
      width: '80%',
      height: '80%',
      overflow: 'auto',
    },
  }));

  const updateDataValue = async () => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/quantidadeAssinantes`)
      .then(async (res) => {
        const totalUsuarios = Number(res?.data?.users?.qtd || 0);
        const usuariosIds = Array.isArray(res?.data?.users?.id_usuario)
          ? res.data.users.id_usuario
          : [];
        const assinantes = Array.isArray(res?.data?.assinantes)
          ? res.data.assinantes
          : [];

        setUsuarios(totalUsuarios);
        const {
          mei,
          simples,
          cancelada,
          expirada,
          suspensa,
          idUsuarioMei,
          idUsuarioSimples,
          idUsuarioCancelada,
          idUsuarioExpirada,
          idUsuarioSuspensa,
        } = await getValuesFromData(assinantes);
        setMei(mei);
        setSimples(simples);
        setCanceladas(cancelada);
        setExpirada(expirada);
        setSuspensa(suspensa);
        const dpu = [
          {
            qtd: totalUsuarios - (mei + simples),
            name: 'Não Assinantes',
            id_usuario: usuariosIds.filter(
              (x) =>
                !idUsuarioMei.includes(x) &&
                !idUsuarioSimples.includes(x) &&
                !idUsuarioCancelada.includes(x) &&
                !idUsuarioExpirada.includes(x) &&
                !idUsuarioSuspensa.includes(x)
            ),
          },
          {
            qtd: mei + simples,
            name: 'Assinantes',
            id_usuario: idUsuarioMei.concat(idUsuarioSimples),
          },
          {
            qtd: cancelada,
            name: 'Canceladas',
            id_usuario: idUsuarioCancelada,
          },
          { qtd: expirada, name: 'Expiradas', id_usuario: idUsuarioExpirada },
          { qtd: suspensa, name: 'Suspensas', id_usuario: idUsuarioSuspensa },
        ];
        setDadosPizzaUser(dpu);
        const dpa = [
          { qtd: mei, name: 'MEI', id_usuario: idUsuarioMei },
          { qtd: simples, name: 'Simples', id_usuario: idUsuarioSimples },
        ];
        setDadosPizzaAssinatura(dpa);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getValuesFromData = async (data) => {
    const loadedData = Array.isArray(data) ? data : [];
    let mei = 0;
    let idUsuarioMei = [];
    let simples = 0;
    let idUsuarioSimples = [];
    let cancelada = 0;
    let idUsuarioCancelada = [];
    let expirada = 0;
    let idUsuarioExpirada = [];
    let suspensa = 0;
    let idUsuarioSuspensa = [];

    for (const d of loadedData) {
      if (d.status === 'Ativa' && d.id_plano_assinatura === 1) {
        mei += Number(d.qtd);
        idUsuarioMei = idUsuarioMei.concat(d.id_usuario);
      } else if (d.status === 'Ativa' && d.id_plano_assinatura === 2) {
        simples += Number(d.qtd);
        idUsuarioSimples = idUsuarioSimples.concat(d.id_usuario);
      } else if (d.status === 'Cancelado') {
        cancelada += Number(d.qtd);
        idUsuarioCancelada = idUsuarioCancelada.concat(d.id_usuario);
      } else if (d.status === 'Suspensa') {
        suspensa += Number(d.qtd);
        idUsuarioExpirada = idUsuarioExpirada.concat(d.id_usuario);
      } else if (d.status === 'Expirada') {
        expirada += Number(d.qtd);
        idUsuarioSuspensa = idUsuarioSuspensa.concat(d.id_usuario);
      }
    }

    return {
      mei,
      simples,
      cancelada,
      expirada,
      suspensa,
      idUsuarioMei,
      idUsuarioSimples,
      idUsuarioCancelada,
      idUsuarioExpirada,
      idUsuarioSuspensa,
    };
  };

  const updateDataBarra = async (d) => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/evolucaoAssinantes?data=${d}`)
      .then((res) => {
        setAnoBarra(d);
        setDadosBarra(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getInfoUsers = async (id_usuario) => {
    setLoading(true);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/contatosClientes`, {
        id_usuario,
      })
      .then((res) => {
        setContatos(Array.isArray(res?.data) ? res.data : []);
        setLoading(false);
        setOpenModal(true);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const [usuarios, setUsuarios] = useState(0);
  const [mei, setMei] = useState(0);
  const [simples, setSimples] = useState(0);
  const [canceladas, setCanceladas] = useState(0);
  const [expirada, setExpirada] = useState(0);
  const [suspensa, setSuspensa] = useState(0);
  const [anoBarra, setAnoBarra] = useState(moment());
  const [dadosBarra, setDadosBarra] = useState([]);
  const [dadosPizzaUser, setDadosPizzaUser] = useState([]);
  const [dadosPizzaAssinatura, setDadosPizzaAssinatura] = useState([]);
  const [contatos, setContatos] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const columns = [
    { id: 1, title: 'Nome', field: 'nome' },
    { id: 2, title: 'E-mail', field: 'email' },
    { id: 3, title: 'Telefone', field: 'telefone' },
  ];

  const classes = useStyles();

  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-evenly"
        alignItems="flex-start"
      >
        <Grid item>
          <CardCustom
            title="Usuários"
            value={usuarios}
            updateValue={updateDataValue}
          />
        </Grid>
        <Grid item>
          <CardCustom
            title="Assinantes"
            value={mei + simples}
            updateValue={updateDataValue}
            class
          />
        </Grid>
      </Grid>
      <Grid container className={classes.cards}>
        <Barra
          title="Novos Usuários"
          data={dadosBarra}
          getInfoUsers={getInfoUsers}
          updateValue={updateDataBarra}
          date={anoBarra}
          barInfo={[
            {
              datakey: 'qtd_usuario',
              name: 'Numero de Usuário',
              label: 'qtd_usuario',
            },
          ]}
        />
      </Grid>
      <Grid container className={classes.cards}>
        <Barra
          title="Novos Assinantes"
          data={dadosBarra}
          getInfoUsers={getInfoUsers}
          updateValue={updateDataBarra}
          date={anoBarra}
          barInfo={[
            {
              datakey: 'qtd_assinatura_mei',
              name: 'MEI',
              label: 'qtd_assinatura_mei',
            },
            {
              datakey: 'qtd_assinatura_simples',
              name: 'Simples',
              label: 'qtd_assinatura_simples',
            },
          ]}
        />
      </Grid>
      <Grid container className={classes.cards}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Pizza
            title="Usuários/Assinantes"
            data={dadosPizzaUser}
            getInfoUsers={getInfoUsers}
            updateValue={updateDataValue}
            dk="qtd"
            nomeLegenda="name"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Pizza
            title="Assinantes"
            data={dadosPizzaAssinatura}
            getInfoUsers={getInfoUsers}
            updateValue={updateDataValue}
            dk="qtd"
            nomeLegenda="name"
          />
        </Grid>
      </Grid>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setContatos([]);
        }}
      >
        {loading ? (
          <Backdrop open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <div className={classes.paper}>
            <div align="center">
              <h2 id="simple-modal-title" align="center">
                Usuários
              </h2>
            </div>
            <TableContainer>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align="center"
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.title}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contatos.map((row) => {
                    return (
                      <TableRow tabIndex={-1} key={row.id}>
                        <TableCell align="center">{row.nome}</TableCell>
                        <TableCell align="center">{row.email}</TableCell>
                        <TableCell align="center">{row.telefone}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </Modal>
    </>
  );
}

export default Financeiro;
